// Constants
import { PlannerPersistedObjectStoreIndexNames, PlannerPersistedObjectStoreKeys } from "@ms/uno-constants/lib/local/PersistenceConstants";
import { TableName } from "@ms/uno-constants/lib/local/StoreConstants";
import { QueryRelationship } from "../planner/EntityRelationships";
import { collection, status } from "@ms/uno-utilities/lib/local/storage/TableNameUtilities";
/** indexes for mru data */ const mruIndexes = [
    {
        name: PlannerPersistedObjectStoreIndexNames.MruPinnedIndex,
        isUnique: false,
        isMultiEntry: false
    }
];
/** indexes for buckets data */ const bucketIndexes = [
    {
        name: PlannerPersistedObjectStoreIndexNames.BucketsPlanIndex,
        isUnique: false,
        isMultiEntry: false
    }
];
/** indexes for goals data */ const goalIndexes = [
    {
        name: PlannerPersistedObjectStoreIndexNames.GoalsPlanIndex,
        isUnique: false,
        isMultiEntry: false
    }
];
/** indexes for task store */ const taskIndexes = [
    {
        name: PlannerPersistedObjectStoreIndexNames.TasksPlanIndex,
        isUnique: false,
        isMultiEntry: false
    },
    {
        name: PlannerPersistedObjectStoreIndexNames.TasksMyDayDateIndex,
        isUnique: false,
        isMultiEntry: false
    },
    {
        name: PlannerPersistedObjectStoreIndexNames.TasksAssigneeIdentityIdIndex,
        isUnique: false,
        isMultiEntry: true
    }
];
/** indexes for custom fields definition data */ const cfdIndexes = [
    {
        name: PlannerPersistedObjectStoreIndexNames.CfdPlanIndex,
        isUnique: false,
        isMultiEntry: false
    }
];
/** indexes for custom view data */ const customViewIndexes = [
    {
        name: PlannerPersistedObjectStoreIndexNames.CustomViewPlanIndex,
        isUnique: false,
        isMultiEntry: false
    }
];
/** indexes for chat message store */ const chatMessageIndexes = [
    {
        name: PlannerPersistedObjectStoreIndexNames.ChatMessagesParentEntityIndex,
        isUnique: false,
        isMultiEntry: false
    }
];
/** indexes for dependency store */ const dependencyIndexes = [
    {
        name: PlannerPersistedObjectStoreIndexNames.DependencyPlanIndex,
        isUnique: false,
        isMultiEntry: false
    }
];
/** mru object store schema */ const mruStoreSchema = {
    /** name of the object store */ name: TableName.Mru,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Mru,
    /** object store indexes */ indexes: mruIndexes
};
const sprintStoreSchema = {
    name: TableName.Sprints,
    keyPath: PlannerPersistedObjectStoreKeys.Sprints,
    indexes: [
        {
            name: PlannerPersistedObjectStoreIndexNames.SprintsPlanIndex,
            isUnique: false,
            isMultiEntry: false
        }
    ]
};
const sprintsInPlanStatusSchema = {
    name: collection(TableName.Sprints, QueryRelationship.SprintsInPlan),
    keyPath: PlannerPersistedObjectStoreKeys.Status,
    indexes: []
};
/** plans object store schema */ const planStoreSchema = {
    /** name of the object store */ name: TableName.Plan,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Plans,
    /** object store indexes */ indexes: []
};
const plannerDefaultPlanIdStoreSchema = {
    name: TableName.PlannerDefaultPlanId,
    keyPath: PlannerPersistedObjectStoreKeys.PlannerDefaultPlanId,
    indexes: []
};
/** plan status schema */ const planStatusSchema = {
    /** name of the object store */ name: status(TableName.Plan),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** Buckets objects store schema */ const bucketStoreSchema = {
    /** name of the object store */ name: TableName.Bucket,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Buckets,
    /** object store indexes */ indexes: bucketIndexes
};
/** buckets in plan status schema */ const bucketsInPlanStatusSchema = {
    /** name of the object store */ name: collection(TableName.Bucket, QueryRelationship.BucketsInPlan),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** Goals objects store schema */ const goalStoreSchema = {
    /** name of the object store */ name: TableName.Goal,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Goals,
    /** object store indexes */ indexes: goalIndexes
};
/** goals in plan status schema */ const goalsInPlanStatusSchema = {
    /** name of the object store */ name: collection(TableName.Goal, QueryRelationship.GoalsInPlan),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** tasks object store schema */ const taskStoreSchema = {
    /** name of the object store */ name: TableName.Tasks,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Tasks,
    /** object store indexes */ indexes: taskIndexes
};
/** tasks in plan status schema */ const tasksInPlanStatusSchema = {
    /** name of the object store */ name: collection(TableName.Tasks, QueryRelationship.TasksInPlan),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** tasks by assignee status schema */ const tasksByAssigneeStatusSchema = {
    /** name of the object store */ name: collection(TableName.Tasks, QueryRelationship.TasksAssignedToUser),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** tasks in my day status schema */ const tasksInMyDayStatusSchema = {
    /** name of the object store */ name: collection(TableName.Tasks, QueryRelationship.TasksInMyDayOfUser),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** View config objects store schema */ const viewConfigStoreSchema = {
    /** name of the object store */ name: TableName.ViewConfig,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.ViewConfig,
    /** object store indexes */ indexes: []
};
/** CFD objects store schema */ const cfdStoreSchema = {
    /** name of the object store */ name: TableName.CustomFieldDefinitions,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Cfd,
    /** object store indexes */ indexes: cfdIndexes
};
/** CFDs in plan status schema */ const cfdsInPlanStatusSchema = {
    /** name of the object store */ name: collection(TableName.CustomFieldDefinitions, QueryRelationship.CustomFieldDefinitionsInPlan),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** Custom views object store schema */ const customViewStoreSchema = {
    /** name of the object store */ name: TableName.CustomViews,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.CustomView,
    /** object store indexes */ indexes: customViewIndexes
};
/** Custom views in plan status schema */ const customViewsInPlanStatusSchema = {
    /** name of the object store */ name: collection(TableName.CustomViews, QueryRelationship.CustomViewsInPlan),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** Pinned tasks object store schema */ const pinnedTasksStoreSchema = {
    /** name of the object store */ name: TableName.PinnedTasks,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.PinnedTasks,
    /** object store indexes */ indexes: []
};
/** Task-order object store schema */ const taskOrderStoreSchema = {
    /** name of the object store */ name: TableName.TaskOrder,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.TaskOrder,
    /** object store indexes */ indexes: []
};
/** Chat message store schema */ const chatMessageStoreSchema = {
    /** name of the object store */ name: TableName.ChatMessage,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.ChatMessages,
    /** object store indexes */ indexes: chatMessageIndexes
};
/** ChatMessagesForTask status schema */ const chatMessagesForTaskStatusSchema = {
    name: collection(TableName.ChatMessage, QueryRelationship.ChatMessagesForTask),
    keyPath: PlannerPersistedObjectStoreKeys.Status,
    indexes: []
};
/** ChatMessagesForPlan status schema — see interface comment for follow-ups owed before plan-chat ships. */ const chatMessagesForPlanStatusSchema = {
    name: collection(TableName.ChatMessage, QueryRelationship.ChatMessagesForPlan),
    keyPath: PlannerPersistedObjectStoreKeys.Status,
    indexes: []
};
/** Dependencies object store schema */ const dependencyStoreSchema = {
    name: TableName.Dependency,
    keyPath: PlannerPersistedObjectStoreKeys.Dependencies,
    indexes: dependencyIndexes
};
/** DependenciesInPlan status schema */ const dependenciesInPlanStatusSchema = {
    name: collection(TableName.Dependency, QueryRelationship.DependenciesInPlan),
    keyPath: PlannerPersistedObjectStoreKeys.Status,
    indexes: []
};
/** Dynamic-filter object store schema */ const dynamicFilterStoreSchema = {
    /** name of the object store */ name: TableName.DynamicFilter,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.DynamicFilter,
    /** object store indexes */ indexes: []
};
/** User photos object store schema (device-local base64 data URIs) */ const userPhotosStoreSchema = {
    /** name of the object store */ name: TableName.UserPhotos,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Photos,
    /** object store indexes */ indexes: []
};
/** User photo status schema (tracks fetch state/timestamp for staleness) */ const userPhotosStatusSchema = {
    /** name of the object store */ name: status(TableName.UserPhotos),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** Modern group photos object store schema (device-local base64 data URIs) */ const modernGroupPhotosStoreSchema = {
    /** name of the object store */ name: TableName.ModernGroupPhotos,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Photos,
    /** object store indexes */ indexes: []
};
/** Modern group photo status schema (tracks fetch state/timestamp for staleness) */ const modernGroupPhotosStatusSchema = {
    /** name of the object store */ name: status(TableName.ModernGroupPhotos),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** User profile object store schema — keyed by user ID for fast facepile hydration on cold start. */ const userStoreSchema = {
    name: TableName.Users,
    keyPath: PlannerPersistedObjectStoreKeys.Users,
    indexes: []
};
/** User fetch-status object store schema — keyed by user ID, stores timestamp and failure state. */ const userStatusSchema = {
    name: status(TableName.Users),
    keyPath: PlannerPersistedObjectStoreKeys.Status,
    indexes: []
};
/** Planner browser cache async storage object store schema */ export const PersistedObjectStoreSchema = [
    mruStoreSchema,
    planStoreSchema,
    plannerDefaultPlanIdStoreSchema,
    planStatusSchema,
    taskStoreSchema,
    tasksInPlanStatusSchema,
    tasksByAssigneeStatusSchema,
    tasksInMyDayStatusSchema,
    bucketsInPlanStatusSchema,
    bucketStoreSchema,
    goalStoreSchema,
    goalsInPlanStatusSchema,
    viewConfigStoreSchema,
    cfdStoreSchema,
    cfdsInPlanStatusSchema,
    customViewStoreSchema,
    customViewsInPlanStatusSchema,
    sprintStoreSchema,
    sprintsInPlanStatusSchema,
    pinnedTasksStoreSchema,
    taskOrderStoreSchema,
    dynamicFilterStoreSchema,
    userPhotosStoreSchema,
    userPhotosStatusSchema,
    modernGroupPhotosStoreSchema,
    modernGroupPhotosStatusSchema,
    chatMessageStoreSchema,
    chatMessagesForTaskStatusSchema,
    chatMessagesForPlanStatusSchema,
    dependencyStoreSchema,
    dependenciesInPlanStatusSchema,
    userStoreSchema,
    userStatusSchema
];
